export default {
  cookies: {
    weUseCookies: 'Utilizamos cookies en la prestación de nuestros servicios.',
    learnMore: 'Para conocer las cookies que utilizamos e información sobre sus preferencias y opciones de exclusión voluntaria, haga ',
    learnMoreClickHere: 'clic aquí',
    learnMoreEnd: '.',
    decline: 'Rechazar',
    allow: 'Permitir',
    showPrivacyPolicy: 'Mostrar política de privacidad'
  }
};